export const buildContactInboxOptions = inboxes =>
  inboxes.map(inbox => ({
    label: inbox.name,
    value: inbox.id,
  }));

export const resolveContactInboxId = ({
  isNewContact,
  inboxOptions,
  currentInboxId,
}) => {
  if (!isNewContact || currentInboxId || inboxOptions.length !== 1) {
    return currentInboxId;
  }

  return inboxOptions[0].value;
};
